let IslandFullRedirector = xClass("IslandFullRedirector", BaseRedirector)
IslandFullRedirector.prototype.getName = function () {
    return "island_full"
}
IslandFullRedirector.prototype.redirect = function () {
    let param = this.param;

    console.log("IslandFullRedirector start...", param);

    let um = UserManager.getInstance();
    if (!Object.keys(um.settings.data).length) {
        // um还没解析login, 等待下次执行
        return false;
    }

    //  检查是否为点自己的链接
    let uid = um.uid;
    let inviteCode = param["inviteCode"] == null? null: +param["inviteCode"];
    let isMythis = inviteCode === uid || false;
    if (isMythis) {
        Toast.make(getText("coin.match.share.self"));
        return true;
    }

    let needCheckNewUser = true;

    let http = IslandFullClickShareHttp.new();
    if (!http)
        return false;

    let shareId = param["shareId"] || "";

    //  检查是否为新玩家
    if (needCheckNewUser) {
        if (!_G.kIsNewUser) {
            console.log("不是新玩家");
            return true;
        } else if (_G.isGetNewUserReward) {
            console.log("大哥你别想着刷奖了");
            return true;
        } else {
            console.log("是新玩家");
        } 
    }

    //  向服务端发送回执
    return new Promise((resolve, reject)=> {        
        http.addEventListener(Events.kComplete, function (evt) {
            console.log("帮助好友成功");
            _G.isGetNewUserReward = true;
            resolve()
        })
        http.addEventListener(Events.kError, function (evt) {
            Toast.make(curryQuickGetErrorText(evt.data), 1, function () {})
            console.log("帮助好友失败");
            resolve()
        })
        http.addEventListener(Events.kCancel, function () {
            Toast.make(curryQuickGetErrorText(0), 1, function () {})
            console.log("帮助好友失败");
            resolve()
        })
        http.load(inviteCode, shareId);

        console.log("IslandFullRedirector requested...");
    });
}

IslandFullRedirector.prototype.hasHighPriorityAction = function () {
    return false;
}

module.exports = IslandFullRedirector